var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dense":"","prominent":"","type":"success"}},[_vm._v("登录授权中")])
}
var staticRenderFns = []

export { render, staticRenderFns }